import { CollectionScopedContextProvider as e, CollectionContextProvider as r } from "./5CPL3B7G.js";
import { createStoreContext as C } from "./VOQWLFSQ.js";
import { createContext as t } from "react";
var o = C(
  [r],
  [e]
), x = o.useContext, d = o.useProviderContext, m = o.ContextProvider, p = o.ScopedContextProvider, s = t(
  void 0
), a = t(
  void 0
);
export {
  m as CompositeContextProvider,
  s as CompositeItemContext,
  a as CompositeRowContext,
  p as CompositeScopedContextProvider,
  x as useCompositeContext,
  d as useCompositeProviderContext
};
//# sourceMappingURL=APTFW6PT.js.map
